<template>
  <!-- MENU CONTAINER SECTION BACKGROUND -->
  <div class="menu_container_section_background">
    <!-- MENU CONTAINER SECTION CONTAINER -->
    <div class="col-md-12 menu_container_section_container">

       

       <div class="menu_container_section_"  @click="setRouter('atribuir-turmas')">
        <figure class="menu_container_section_img">
          <img src="img/boletims.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Atribuição de  Turmas</span>
        </div>
      </div>   

      <div class="menu_container_section_"  @click="setRouter('listagem')">
        <figure class="menu_container_section_img">
          <img src="img/listarDados.png" />
        </figure>
        <div class="menu_container_section_text_container">
          <span class="menu_container_section_text_title">Listagem de professores</span>
        </div>
      </div>   

      
    </div>
    <!-- FIM MENU CONTAINER SECTION CONTAINER -->
  </div>
  <!-- FIM MENU CONTAINER SECTION BACKGROUND -->
</template>
<script>
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
     
     data: ()=>({

     }),
     computed:{
        role(){
           return ls.get('role')
        }
     },

     methods: {
        
           setRouter(router){
              this.$router.push(router)
           },

           IndisponivelMomento (){
             Swal.fire('Informação','Funcionalidade indisponível de momento.','warning')
           }

     }

}
</script>
